import { CardType } from '../constants/payments';
import { pushEventInfo, setPageDetails, track } from './analytics';
import { CardBrandFilterValueAnalytics, FilterByAnalytics, } from '../constants/credit-card';
import { getAnalyticsCardBrand } from './credit-cards';
import { AUTHORIZE_CARD_REMOTE_PURCHASES_BUTTON_CLICK } from '../constants/analytics';
const EVENT_CATEGORIES = {
    BUTTON_SUBMISSION: 'button submission',
    STASH: 'stash',
};
const EVENT_NAMES = {
    ACCOUNT_SETTINGS: 'my account settings',
};
const EVENT_MODES = {
    STASH: 'stash',
};
export const setPaymentsPageAnalytics = () => {
    const page = {
        category: {
            primaryCategory: 'account',
            subCategory1: 'account>payments',
            subCategory2: 'account>payments',
        },
        pageInfo: {
            pageName: 'account>payments',
            pageType: 'maml:cards and accounts',
        },
        error: [],
    };
    setPageDetails(page);
};
const tenderNames = {
    [CardType.CREDIT_CARD]: 'credit cards',
    [CardType.PRO_XTRA_DOLLARS]: 'pro xtra dollars',
    [CardType.GIFT_CARD]: 'gift cards',
    [CardType.PAYPAL_ACCOUNT]: 'paypal',
    [CardType.CHECKING_ACCOUNT]: 'checking accounts',
    [CardType.KEY_TAG]: 'keytags',
    [CardType.PRO_HOUSE_ACCOUNT]: 'pro house account',
};
export const setCardSearchAnalytics = (listView, filterBy, filterValue) => {
    const selectedView = listView ? 'list' : 'grid';
    const thdAnalyticsEvent = {
        category: {
            primaryCategory: EVENT_CATEGORIES.BUTTON_SUBMISSION,
        },
        eventInfo: {
            eventName: EVENT_NAMES.ACCOUNT_SETTINGS,
        },
        myAccount: {
            settings: `cards and accounts: ${selectedView}: credit cards: search`,
            searchTerm: 'n/a',
            searchBy: `${FilterByAnalytics[filterBy]}: ${CardBrandFilterValueAnalytics[filterValue]}`,
        },
    };
    pushEventInfo(thdAnalyticsEvent);
};
export const setCardSortAnalytics = (listView, sortBy, orderValue) => {
    const selectedView = listView ? 'list' : 'grid';
    const thdAnalyticsEvent = {
        category: {
            primaryCategory: EVENT_CATEGORIES.BUTTON_SUBMISSION,
        },
        eventInfo: {
            eventName: EVENT_NAMES.ACCOUNT_SETTINGS,
        },
        myAccount: {
            settings: `cards and accounts: ${selectedView}: credit cards: sort`,
            searchTerm: `${sortBy.toLowerCase()}: ${orderValue.toLowerCase()}`,
            searchBy: 'n/a',
        },
    };
    pushEventInfo(thdAnalyticsEvent);
};
export const setTenderTypeSelectionAnalytics = (cardType) => {
    const event = {
        category: {
            primaryCategory: EVENT_CATEGORIES.BUTTON_SUBMISSION,
        },
        eventInfo: {
            eventName: EVENT_NAMES.ACCOUNT_SETTINGS,
        },
        myAccount: {
            settings: `cards and accounts: tender: ${tenderNames[cardType]}`,
        },
    };
    pushEventInfo(event);
};
export const setMeatballsAnalytics = (meatballAction, cardType, cardBrand, paymentCardType, locType, t2cPrimary) => {
    const brand = cardBrand
        ? getAnalyticsCardBrand(cardBrand, paymentCardType, locType, t2cPrimary)
        : '';
    const event = {
        category: {
            primaryCategory: EVENT_CATEGORIES.STASH,
        },
        eventInfo: {
            eventName: EVENT_NAMES.ACCOUNT_SETTINGS,
        },
        eventMode: EVENT_MODES.STASH,
        stash: {
            myAccount: {
                settings: `cards and accounts: ${tenderNames[cardType]}: meatball: ${meatballAction}${brand ? ': ' + brand : ''}`,
            },
        },
    };
    pushEventInfo(event);
};
export const setAddCardAnalytics = (cardName, isDefault, cardBrand, cardType) => {
    const brand = cardBrand ? getAnalyticsCardBrand(cardBrand, cardType) : '';
    const creditCardSettings = `cards and accounts: added credit card:${isDefault ? '' : ' not'} default${brand ? ': ' + brand : ''}`;
    const event = {
        category: {
            primaryCategory: EVENT_CATEGORIES.BUTTON_SUBMISSION,
        },
        eventInfo: {
            eventName: EVENT_NAMES.ACCOUNT_SETTINGS,
        },
        myAccount: {
            settings: cardName === 'credit card'
                ? creditCardSettings
                : `cards and accounts: added ${cardName}`,
        },
    };
    pushEventInfo(event);
};
export const setEditCardAnalytics = (cardName, isDefault, cardBrand, cardType) => {
    const brand = cardBrand ? getAnalyticsCardBrand(cardBrand, cardType) : '';
    const creditCardSettings = `cards and accounts: edited credit card:${isDefault ? '' : ' not'} default${brand ? ': ' + brand : ''}`;
    const event = {
        category: {
            primaryCategory: EVENT_CATEGORIES.BUTTON_SUBMISSION,
        },
        eventInfo: {
            eventName: EVENT_NAMES.ACCOUNT_SETTINGS,
        },
        myAccount: {
            settings: cardName === 'credit card'
                ? creditCardSettings
                : `cards and accounts: edited ${cardName}`,
        },
    };
    pushEventInfo(event);
};
export const setDeleteCardAnalytics = (cardName, isDefault, cardBrand, cardType) => {
    const brand = cardBrand ? getAnalyticsCardBrand(cardBrand, cardType) : '';
    const creditCardSettings = `cards and accounts: deleted credit card:${isDefault ? '' : ' not'} default${brand ? ': ' + brand : ''}`;
    const event = {
        category: {
            primaryCategory: EVENT_CATEGORIES.BUTTON_SUBMISSION,
        },
        eventInfo: {
            eventName: EVENT_NAMES.ACCOUNT_SETTINGS,
        },
        myAccount: {
            settings: cardName === 'credit card'
                ? creditCardSettings
                : `cards and accounts: deleted ${cardName}`,
        },
    };
    pushEventInfo(event);
};
export const setSuccessSetAsDefaultCardAnalytics = () => {
    const event = {
        category: {
            primaryCategory: EVENT_CATEGORIES.BUTTON_SUBMISSION,
        },
        eventInfo: {
            eventName: EVENT_NAMES.ACCOUNT_SETTINGS,
        },
        myAccount: {
            settings: 'cards and accounts: set as default: default',
        },
    };
    pushEventInfo(event);
};
export const setViewPurchasesStashEvent = (cardType, cardBrand, paymentCardType) => {
    const brand = cardBrand
        ? getAnalyticsCardBrand(cardBrand, paymentCardType)
        : '';
    const event = {
        category: {
            primaryCategory: EVENT_CATEGORIES.STASH,
        },
        eventInfo: {
            eventName: EVENT_NAMES.ACCOUNT_SETTINGS,
        },
        eventMode: EVENT_MODES.STASH,
        stash: {
            myAccount: {
                settings: `cards and accounts: ${tenderNames[cardType]}: meatball: view purchases${brand ? ': ' + brand : ''}`,
            },
        },
    };
    pushEventInfo(event);
};
export const setTopLinksAnalytics = (topLinks) => {
    const event = {
        category: {
            primaryCategory: EVENT_CATEGORIES.BUTTON_SUBMISSION,
        },
        eventInfo: {
            eventName: EVENT_NAMES.ACCOUNT_SETTINGS,
        },
        myAccount: {
            settings: `credit cards : top links : ${topLinks}`,
        },
    };
    pushEventInfo(event);
};
export const setOtherButtonSubmissionAnalytics = (message) => {
    const event = {
        category: {
            primaryCategory: EVENT_CATEGORIES.BUTTON_SUBMISSION,
        },
        eventInfo: {
            eventName: EVENT_NAMES.ACCOUNT_SETTINGS,
        },
        myAccount: {
            settings: `cards and accounts: ${message}`,
        },
    };
    pushEventInfo(event);
};
export const setDeleteCardOverlayAnalytics = () => {
    const event = {
        category: {
            primaryCategory: 'overlay',
        },
        eventInfo: {
            eventName: 'do you want to delete your home depot credit cards',
        },
    };
    pushEventInfo(event);
};
export const setContactOverlayAnalytics = () => {
    const event = {
        category: {
            primaryCategory: 'overlay',
        },
        eventInfo: {
            eventName: 'contact citi to set card inactive',
        },
    };
    pushEventInfo(event);
};
export const setTableViewPaginationAnalytics = ({ rows, isSearchActive, filterType, currentPageNumber, }) => {
    const isCityCardPaginating = isSearchActive && filterType === 'citiID';
    setPaginationAnalytics({
        viewType: 'list',
        viewNumber: rows,
        pageNumber: currentPageNumber,
        isCitiCard: isCityCardPaginating,
    });
};
export const setPaginationAnalytics = ({ viewType, viewNumber, pageNumber, isCitiCard, }) => {
    let settings = `cards and accounts: ${viewType}: tender: credit cards: `;
    settings += isCitiCard ? 'citi: ' : '';
    settings += pageNumber
        ? `pagination: view ${viewNumber}`
        : `view ${viewNumber}`;
    settings += pageNumber ? `: page ${pageNumber}` : '';
    const event = {
        category: {
            primaryCategory: EVENT_CATEGORIES.BUTTON_SUBMISSION,
        },
        eventInfo: {
            eventName: EVENT_NAMES.ACCOUNT_SETTINGS,
        },
        myAccount: {
            settings,
        },
    };
    pushEventInfo(event);
};
export const setSuccessAuthorizationAnalytics = (action, isProxCard, t2cPrimary) => {
    const t2cType = t2cPrimary ? 'primary' : 'secondary';
    const getAuthType = () => {
        switch (action) {
            case 'PHONE_AUTH':
            case 'REMOVE_PHONE_AUTH':
                return 'phone';
            case 'T2C':
            case 'REMOVE_T2C':
                return 't2c';
            case 'PHONE_AUTH_AND_T2C':
            case 'REMOVE_PHONE_AUTH_AND_T2C':
                return 'both';
            default:
                return '';
        }
    };
    const authType = getAuthType();
    if (authType)
        setOtherButtonSubmissionAnalytics(`credit cards ${t2cType}: remote purchase ${action.startsWith('REMOVE') ? 'approval removal' : 'auth'} success: ${isProxCard ? 'px' : 'npx'}: ${authType}`);
};
export const setPTCSuccessAuthorizationAnalytics = (options) => {
    const { locType, t2cPrimary, action } = options;
    const formattedLocType = (locType || '').toLowerCase();
    const t2cType = t2cPrimary ? 'primary' : 'secondary';
    track(AUTHORIZE_CARD_REMOTE_PURCHASES_BUTTON_CLICK, {
        section: `pro house ${formattedLocType} ${t2cType}`,
        actionType: `remote purchase ${action === 'enroll' ? 'auth' : 'approval removal'} success: t2c`,
    });
};
// Errors
export const setCardSearchSortPostPageErrorAnalytics = (postPageError) => {
    const thdAnalyticsEvent = {
        category: {
            primaryCategory: 'error',
        },
        eventInfo: {
            eventName: 'post page error',
            error: [
                {
                    type: 'advisory',
                    displayType: 'inline',
                    pageSection: 'card sort and search',
                    message: postPageError.toLowerCase(),
                    code: 'n/a',
                },
            ],
        },
    };
    pushEventInfo(thdAnalyticsEvent);
};
export const creditCardRemotePurchasesPostPageErrorAnalytics = (postPageError, errorCode) => {
    track('cc-remote-purchases.post-page-error', {
        type: 'error',
        displayType: 'inline',
        pageSection: 'authorize credit card',
        message: postPageError,
        code: errorCode || 'n/a',
    });
};
export const ptcRemotePurchasesPtcPostPageErrorAnalytics = (postPageError, errorCode) => {
    track('ptc-remote-purchases.post-page-error', {
        type: 'error',
        displayType: 'inline',
        pageSection: 'authorize pro trade credit',
        message: postPageError,
        code: errorCode || 'n/a',
    });
};
